'use strict';

module.exports = {
    SYSTEM_CONNECTED_EVENT_TYPE: 'system.connected',
    JET_STARTUP_EVENT_TYPE: 'jet.startup'
};